import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/OperatorRequestActions";
import * as api from "../../api/OperatorRequestApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showInfoSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import moment from "moment";

function* getCreatorsList(action) {
    try {
        const { data } = yield api.getCreatorList(action.payload.status);
        if (action.payload.updatedStatus) {
            yield put(actions.setCreatorList(data || undefined));
        } else {
            yield put(actions.setCreatorList({ response: data } || undefined));
            yield put(actions.getStatusList());
        }
    } catch (error) {
        yield put(actions.setCreatorList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCancelOrder(action) {
    yield put(resetBackdrop());
    try {
        console.log(action.payload);
        const { data } = yield api.getCancelOrder(action.payload);

        yield put(actions.setCancelOrder(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getConfirmOrder(action) {
    yield put(resetBackdrop());
    try {
        console.log(action.payload);
        const { data } = yield api.getConfirmOrder(action.payload);

        yield put(actions.setConfirmOrder(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getStatusList() {
    try {
        const { data } = yield api.getStatusList();
        yield put(actions.setStatusList(data || undefined));
    } catch (error) {
        yield put(actions.setStatusList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_CREATORS, getCreatorsList);
    yield takeEvery(actions.Types.GET_STATUS, getStatusList);
    yield takeEvery(actions.Types.GET_CANCEL_ORDER, getCancelOrder);
    yield takeEvery(actions.Types.GET_CONFIRM_ORDER, getConfirmOrder);
    yield takeEvery(actions.Types.GET_EXCEL_FILE, downloadExcelFile);
}

function* downloadExcelFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.downloadExcelFile(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_OperatorRequests_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx";
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(setBackdrop());
    }
    yield put(setBackdrop());
}

const operatorRequestSaga = [fork(watchAll)];

export default operatorRequestSaga;
